import { render, staticRenderFns } from "./comp_dpc-AppbarImagesSlider.vue?vue&type=template&id=e6ae80c6&scoped=true&"
import script from "./comp_dpc-AppbarImagesSlider.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-AppbarImagesSlider.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-AppbarImagesSlider.vue?vue&type=style&index=0&id=e6ae80c6&prod&lang=css&"
import style1 from "./comp_dpc-AppbarImagesSlider.vue?vue&type=style&index=1&id=e6ae80c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ae80c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
